import React from 'react'
import { View, TouchableOpacity } from 'react-native'

import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import PropTypes from 'prop-types'

import { Icon, VFText, VFButton, Shimmer } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils'


import { getThemeImages } from '../../Themes/Modes'

import { formatDate } from '../../Utils/DateHelpers'
import StoreInfo from '../StoreInfo'

import styles from './AppointmentCard.Styles'


const loadingConfig = theme => [
  {
    style: styles.storeContainer(theme),
    left: setLoadingConfigObject('circle', 1, 40, styles.storeIcon),
    main: setLoadingConfigObject('square', 2, null, styles.storeDetails),
  },
]

const buttonLoadingConfig = theme => [
  {
    style: styles.buttonContainer(theme),
    main: setLoadingConfigObject('line', 1, null, {}),
  },
]

const AppointmentCard = ({
  service,
  store,
  date,
  onGetStoreDirectionsPress,
  formatAppointmentDate,
  containerStyle,
  withCancelBookingButton,
  onCancelBookingPress,
  withChangeBookingPress,
  onChangeBookingPress,
  isStoreLoading,
  ...props
}) => {
  const theme = useTheme()
  const images = getThemeImages(theme.name)


  return (
    <View style={[styles.cardContainer(theme), containerStyle]}>
      {withCancelBookingButton && <TouchableOpacity
        style={styles.cancelViewContainerStyle}
        onPress={() => onCancelBookingPress && onCancelBookingPress()}
      >
        <VFText
          i18nKey="your_appointments_cancel_booking_button"
          style={styles.cancelTextStyle(theme)}
        />
        <Icon name={images.ic_delete} size={21} />
      </TouchableOpacity>}

      <View style={styles.infoContainerStyle}>
        <Icon name={images[service?.image]} size={100} style={styles.serviceIconStyle} />

        <View>
          <VFText i18nKey={service?.title} style={styles.serviceTypeTextStyle(theme)} />
          <VFText i18nKey={service?.description} style={styles.serviceDescription(theme)} />
        </View>

        {isStoreLoading ? <Shimmer
          config={loadingConfig(theme)}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        /> : <>
          {Object.keys(store).length > 0 ? <StoreInfo {...(store || {})} /> : <View style={styles.empty} />}
        </>}

        <VFText
          i18nKey={formatDate(date?.selectedDate, date?.selectedTime, formatAppointmentDate)}
          style={styles.dateTextStyle(theme)}
        />

        <View style={styles.buttonsContainerStyle}>
          {withChangeBookingPress && <VFButton
            type="quaternary"
            title="your_appointments_change_booking_button"
            style={styles.leftButtonStyle}
            textStyle={styles.buttonTextStyle(theme)}
            onPress={() => { }}
          />}

          {isStoreLoading ? <Shimmer
            config={buttonLoadingConfig(theme)}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          /> : <>
            {Object.keys(store).length > 0 && <VFButton
              type="quaternary"
              title="your_appointments_get_store_directions_button"
              style={styles.rightButtonStyle}
              textStyle={styles.buttonTextStyle(theme)}
              onPress={() =>
                onGetStoreDirectionsPress(store?.address?.longitude, store?.address?.latitude)
              }
            />}
          </>}
        </View>
      </View>
    </View>
  )
}
AppointmentCard.defaultProps = {
  isStoreLoading: false
}

AppointmentCard.propTypes = {
  service: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.shape({ uri: PropTypes.string }).isRequired,
  }),
  store: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape({
      name: PropTypes.string,
      longitude: PropTypes.number,
      latitude: PropTypes.number,
    }),
    contactInfo: PropTypes.shape({
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
    }),
  }).isRequired,
  date: PropTypes.shape({
    selectedDate: PropTypes.string,
    selectedTime: PropTypes.string,
  }).isRequired,
  onGetStoreDirectionsPress: PropTypes.func,
  formatAppointmentDate: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  withCancelBookingButton: PropTypes.bool,
  onCancelBookingPress: PropTypes.func,
  isStoreLoading: PropTypes.bool,
}

export default AppointmentCard
